<template>
    <TextButton title="Media Player" link="/media" id="media-subnavigationTitle" />
</template>

<script lang="ts" setup>
    import TextButton from '@/components/Buttons/TextButton.vue'
</script>
